var Curriculog = Curriculog || {};

Curriculog.EntityView = (function ($, _, Backbone, EntityView) {

	EntityView = Curriculog.HierarchyListView.extend({
		template: 'HierarchyList/entityListItem.html',

		initialize: function (options) {
			this.roleViews = {};
			this.roles = options.roles;
			this.users = options.users;
			this.depth = options.depth;
			this.committees = options.committees;
			this.relationship = options.relationship;
			this.userRoles = options.userRoles;
      this.params = options.params;
			this.render();
		},

		render: function () {
			templateData = this.model.toJSON();
			templateData['depth'] = this.depth;
			templateData['relationship'] = this.relationship.toJSON();
      templateData['cui_enabled'] = this.params.cui_enabled;

			var entityID = this.model.get('id');
			templateData['numEntityRoles'] = this.roles.getRoleModelsForEntity(entityID).length;

			this.el = nunjucks.render(this.template, templateData);
			this.replaceElement(this.el);
			this.renderRoles();
		},

		renderRoles: function () {
			var roleID,
				roleModel,
				role,
				committeeID;

			var entityID = this.model.get('id');
			var roleList = this.roles.getRoleModelsForEntity(entityID);

			// Precache the lowercase version of the name so we dont have
			// to recalculate it for each comparison while sorting.
			for(var i = 0, l = roleList.length; i < l; i++){
				roleList[i].nameLower = roleList[i].get('name').toLowerCase();
			}

			roleList = roleList.sort(function (a, b) {
				if (a.nameLower < b.nameLower)
					return -1;
				if (a.nameLower > b.nameLower)
					return 1;
				return 0;
			});

			for (var i = 0; i < roleList.length; i++) {
				roleID = roleList[i];
				roleModel = this.roles.get(roleID);
				role = new Curriculog.RoleView({
					model: roleModel,
					committees: this.committees,
					users: this.users,
					depth: this.depth,
					userRoles: this.userRoles,
          params: this.params
				});
				this.roleViews[roleID] = role;
				this.$('.item-roles').append(role.el);
			}
		},
	});

	return EntityView;

})($, _, Backbone, Curriculog.EntityView || {});
